import type { ReactNode } from 'react';

export const symbol_format_textdirection_vertical: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M253.5-247.63Q245-256.25 245-269v-179q-68 0-116.5-45T80-604q0-66 49-110.5T245-759h270q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-50v430q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-430H305v430q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM719-175q-5-2-10-7L602-290q-8-9-8.5-21.1-.5-12.1 8.5-20.9 9-9 21-9t21 9l56 57v-454q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v454l56-57q9-9 21-9t21.39 9q8.61 9 9.11 21.36.5 12.37-8.5 21.64L751-181q-5 5-10.13 6.5-5.14 1.5-11 1.5-5.87 0-10.87-2ZM245-508v-191q-42 0-73.5 27T140-603.5q0 41.5 31.5 68.5t73.5 27Zm0-96Z"
		/>
	</svg>
);
